import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import {
    Grid,
    Container,
    Paper,
    Typography,
    Divider,
    IconButton,
    Icon,
} from "@mui/material";
import { Loading, Tabs, TabContainer } from "@gpstrackit/react-controls"
import { useIntl } from "react-intl";
//Actions
import {
    manufacturerGetDataRequest,
    manufacturerCreateEditOpenModal,
    syncCTCInformationOpenModal,
    clearRedux,
} from "Redux/actions";

//Components
import SummaryCard from 'Components/SummaryCard';
import MultiLevelSelector from "Components/SelectorMultiLevel";
import ChipStatus from 'Components/ChipStatus';

//Tabs
import Activities from "Modules/activities/.components/tab"
import FirmwareTab from 'Modules/manufacturers/.components/firmwareTab';
import PartNumbersTab from 'Modules/manufacturers/.components/partNumbersTab';
import DevicesModelsTab from 'Modules/manufacturers/.components/deviceModelsTab';
import UnitTypesTab from 'Modules/manufacturers/.components/unitTypesTab';
import VidfleetConfiguration from "Modules/vidfleet/.components/configuration";
import CannedCommandsTab from 'Modules/manufacturers/.components/cannedCommandsTab';
import CreateEditManufacturer from 'Modules/manufacturers/views/.components/createEditManufacturer';
import SyncCTCInformation from 'Modules/manufacturers/views/.components/syncCTCInformation';


//Permission
import { HasPermission } from "Core/security"

//Helpers
import { getDateFormatted } from 'Core/data/Helpers';

const ManufacturerOverview = (props) => {
    const dispatch = useDispatch();
    const { messages } = useIntl();
    const navigate = useNavigate();

    const { loading, manufacturer } = useSelector(state => state.manufacturersOverviewRedux);
    const createEditManuOpenModal = useSelector(state => state.createEditManufacturerRedux.openModal);
    const syncCTCInfoOpenModal = useSelector(state => state.syncCTCInformationRedux.openModal);
    const user = useSelector(state => state.securityRedux.user);
    const { id } = useParams();

    const [tab, setTab] = useState(0);
    const [openSummary, setOpenSummary] = useState(true);

    useEffect(() => {
        dispatch(manufacturerGetDataRequest(id))
        return () => {
            dispatch(clearRedux("MANUFACTURER_OVERVIEW"));
            dispatch(clearRedux("COMMON", { "part-numbers-tab": {}, "firmwares-tab": {}, "device-models-tab": {}, "unit-types-tab": {} }))
        }
    }, []);

    const SummaryItem = (props) => {
        const { label, value } = props;
        return (
            <Grid item xs={4} sm={4}>
                <div style={{ display: 'grid' }}>
                    <span style={{ opacity: 0.6 }} className="text-muted mb-2">
                        {label}
                    </span>
                    {
                        manufacturer ? value() : <div style={{ width: 210, height: 20 }}></div>
                    }
                </div>
            </Grid>
        )
    }

    let activitiesTab = HasPermission(user, "act");
    let firmwareTab = manufacturer?.name?.toUpperCase() === "VidFleet".toUpperCase() && HasPermission(user, "manft");
    let partNumberTab = HasPermission(user, "partn");
    let deviceModelTab = HasPermission(user, "devmod");
    let unitTypeTab = HasPermission(user, "untty");
    let configTab = manufacturer?.name?.toUpperCase() === "VidFleet".toUpperCase() && HasPermission(user, "vftcf");
    let cannedTab = HasPermission(user, "cancom");

    let indexCount = 0;

    let innerHeight = window.innerHeight

    return (
        <Container maxWidth={false} className="container-view">
            {loading && <Loading overlay show />}
            <Paper elevation={0} style={{ overflow: "auto" }}>
                <Grid
                    container
                    direction="row"
                    style={{ padding: "14px 18px", borderBottom: "1px solid #e8e8e8", height: '95vh' }}
                >
                    <Grid item xs={12} style={{ textAlign: 'left' }}>
                        <Grid
                            container
                            direction="row"
                            justifyContent="space-between"
                            alignItems="center"
                        >
                            <Grid item xs={6}>
                                <Typography variant="h5" component="div" style={{ display: 'flex', alignItems: 'center' }}>
                                    <IconButton onClick={() => navigate(-1)} size="large">
                                        <Icon style={{ cursor: "pointer" }} className="toolbar-list-icon">
                                            arrow_back
                                        </Icon>
                                    </IconButton>
                                    <span style={{ marginRight: 5, opacity: 0.6 }}>{messages['manufacturer_main_manufacturer']}:</span> {manufacturer?.name || ''}
                                </Typography>
                            </Grid>
                            <Grid item xs={6} style={{ textAlign: 'end' }}>
                                <MultiLevelSelector
                                    label={messages['account_overview_actions']}
                                    position="left"
                                    options={[
                                        {
                                            id: "edit-manufacturer",
                                            label: messages['edit'],
                                            show: true,
                                            action: () => {
                                                dispatch(manufacturerCreateEditOpenModal(true, manufacturer))
                                            },
                                            disabled: !HasPermission(user, "man", "u"),
                                        },
                                        {
                                            id: "async-information-ctc",
                                            label: messages['manufacturer_main_sync_ctc_information'],
                                            show: manufacturer?.name?.toUpperCase() === "CALAMP",
                                            action: () => {
                                                dispatch(syncCTCInformationOpenModal(true))
                                            },
                                            disabled: false,
                                        },
                                    ]}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Divider style={{ backgroundColor: '#999999' }} />
                            </Grid>
                        </Grid>
                        <SummaryCard
                            onChange={(value) => setOpenSummary(value)}
                            name="manufacturer-summary"
                        >
                            <Grid container>
                                <SummaryItem
                                    label={messages['manufacturer_main_id']}
                                    value={() => {
                                        return (
                                            <div style={{ width: 210, height: 25 }}>
                                                {manufacturer.id}
                                            </div>
                                        )
                                    }}
                                />
                                <SummaryItem
                                    label={messages['manufacturer_main_name']}
                                    value={() => {
                                        return (
                                            <div style={{ width: 210, height: 25 }}>
                                                {manufacturer.name}
                                            </div>
                                        )
                                    }}
                                />
                                <SummaryItem
                                    label={messages['manufacturer_main_status']}
                                    value={() => {
                                        return (
                                            <ChipStatus statusCode={manufacturer?.active ? 1 : 20} messages={messages} />
                                        )
                                    }}
                                />
                                <SummaryItem
                                    label={messages['manufacturer_main_created_on']}
                                    value={() => {
                                        return (
                                            <div style={{ width: 210, height: 25 }}>
                                                {manufacturer?.createdOn && getDateFormatted(manufacturer?.createdOn, "date", "datetime")}
                                            </div>
                                        )
                                    }}
                                />
                            </Grid>
                        </SummaryCard>

                        <Tabs onChange={(numberTab) => { setTab(numberTab) }}>
                            {
                                activitiesTab &&
                                <TabContainer index={indexCount++} key={`menu-${1}`} label={messages['account_overview_activities']}>
                                    {manufacturer?.id &&
                                        <Activities
                                            tab={tab}
                                            height={openSummary ? innerHeight - 395 : innerHeight - 260}
                                            entityName="Manufacturer"
                                            entityId={manufacturer?.id}
                                            noUsers
                                            noFilters2
                                            noOpenSearch
                                        />
                                    }
                                </TabContainer>
                            }
                            {
                                deviceModelTab &&
                                <TabContainer index={indexCount++} key={`menu-${3}`} label={messages['account_overview_device_models']}>
                                    <DevicesModelsTab
                                        tab={tab}
                                        height={openSummary ? innerHeight - 399 : innerHeight - 270}
                                        manufacturer={manufacturer}
                                    />
                                </TabContainer>
                            }
                            {
                                unitTypeTab &&
                                <TabContainer index={indexCount++} key={`menu-${4}`} label={messages['account_overview_unit_types']}>
                                    <UnitTypesTab
                                        tab={tab}
                                        height={openSummary ? innerHeight - 399 : innerHeight - 270}
                                        manufacturer={manufacturer}
                                    />
                                </TabContainer>
                            }
                            {
                                partNumberTab &&
                                <TabContainer index={indexCount++} key={`menu-${5}`} label={messages['account_overview_part_numbers']}>
                                    <PartNumbersTab
                                        tab={tab}
                                        height={openSummary ? innerHeight - 399 : innerHeight - 270}
                                        manufacturer={manufacturer}
                                    />
                                </TabContainer>
                            }
                            {
                                firmwareTab &&
                                <TabContainer index={indexCount++} key={`menu-${6}`} label={messages['manufacturer_main_firmware']}>
                                    <FirmwareTab
                                        tab={tab}
                                        height={openSummary ? innerHeight - 399 : innerHeight - 270}
                                    />
                                </TabContainer>
                            }
                            {
                                configTab &&
                                <TabContainer index={indexCount++} key={`menu-${7}`} label={messages['manufacturer_main_configuration']}>
                                    <VidfleetConfiguration
                                        tab={tab}
                                        height={openSummary ? innerHeight - 399 : innerHeight - 270}
                                        from={"manufacturer"}
                                    />
                                </TabContainer>
                            }
                            {
                                cannedTab &&
                                <TabContainer index={indexCount++} key={`menu-${8}`} label={messages['manufacturer_main_canned_commands']}>
                                    <CannedCommandsTab
                                        tab={tab}
                                        height={openSummary ? innerHeight - 399 : innerHeight - 270}
                                        manufacturer={manufacturer}
                                    />
                                </TabContainer>
                            }
                        </Tabs>
                    </Grid>
                </Grid>
            </Paper>
            {createEditManuOpenModal && <CreateEditManufacturer getData={() => dispatch(manufacturerGetDataRequest(id))} />}
            {syncCTCInfoOpenModal && <SyncCTCInformation />}
        </Container>
    );
}
export default ManufacturerOverview;